import { createEntityWithState } from 'module/Redux/Common';
import { createLocation, Location, LocationDescriptorObject, Path } from 'history';

type Payloads = {
  set: Path | LocationDescriptorObject;
  reset: null;
  isReady: null;
};

export type State = {
  location: Location | null;
  ready: boolean;
};

export const requestedEntity = createEntityWithState<Payloads, State>()(
  'requestedLocation',
  {
    location: null,
    ready: false,
  },
  {},
  {
    set: (s, p) => ({ location: createLocation(p), ready: false }),
    reset: (s, p) => ({ location: null, ready: false }),
    isReady: (s, p) => {
      if (s.location === null) {
        return s;
      }
      return { ...s, ready: true };
    },
  }
);



// WEBPACK FOOTER //
// ./src/module/Redux/Router/requestedEntity.ts